<template>
    <div>
        <layout-header></layout-header>
        <div v-if="showspinner">
            <loader></loader>
        </div>
        <div v-else>
            <div class="main-wrapper">
                <div class="content">
                    <div class="container">
                        <div class="row" style="display:flex;justify-content: center; text-align: center;">
                            <div class="col-md-12 col-lg-12 col-xl-12">
                                <div>
                                    <div class="form-group col-sm-12">
                                        <div class="input-group" v-if="isDataLoaded">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Dr.</span>
                                            </div>
                                            <input type="text" v-model="doctorNameFilter" class="form-control"
                                                placeholder="Search by Doctor's Name" @input="get_doctors()" />
                                        </div>
                                    </div>
                                    <!-- {{ doctors }} -->
                                    <div v-if="doctors.length === 0 && isDataLoaded">
                                        <p style="color: red;">No doctor found</p>
                                    </div>
                                    <div v-else>
                                        <div class="row justify-content-center m-2">
                                            <div class="card m-1" style="width: 380px;" v-for="(item, index) in doctors">
                                                <div class="card-body">
                                                    <div class="doctor-action" style="float: right;">
                                                        <a v-if="user_type === 'patient'" href="javascript:void(0)"
                                                            @click="add_favourite_Doctor(item.name)"
                                                            class="btn btn-white fav-btn"><i class="fa fa-heart"></i></a>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <router-link :to="{
                                                                name: 'doctor-profile',
                                                                params: { name: item.name },
                                                            }">
                                                                <img :src="loadDocImg(item.image)" class="img-fluid"
                                                                    alt="User Image"
                                                                    style="height: 80px; width: 80px; border-radius: 100px;" />
                                                            </router-link>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <h4 class="text-md-left mt-md-0"
                                                                style="font-size: 15px;margin-top: 1rem;">
                                                                <router-link :to="{
                                                                    name: 'doctor-profile',
                                                                    params: { name: item.name },
                                                                }">
                                                                    {{ item.first_name }} {{ item.middle_name }}
                                                                    {{ item.last_name }}
                                                                </router-link>
                                                                <img v-if="item.verification_status"
                                                                    style="height: 15px; background: none;"
                                                                    src="@/assets/img/verifydoc.png" alt="User Image" />
                                                            </h4>
                                                            <p class="text-md-left" style="font-size: 13px;">
                                                                {{ item.healthcare_practitioner_category }}
                                                            </p>
                                                            <p class="doc-department text-md-left">
                                                                {{ get_doctor_qualification(item.qualification) }}
                                                            </p>
                                                            <div class="text-md-left" v-if="item.average_ranking">
                                                                <star-rating v-model="item.average_ranking" :star-size="13"
                                                                    :max-rating="5" :show-rating="false"
                                                                    :read-only="disabledEdit"></star-rating>
                                                                <span class="d-inline-block average-rating">
                                                                    ({{ item.rating }})
                                                                </span>
                                                            </div>
                                                            <p class="text-md-left" style="font-size: small; color: grey;">
                                                                <i class="fas fa-map-marker-alt"></i>
                                                                {{ item.city }}, {{ item.state }}
                                                            </p>
                                                            <div class="clinic-services text-md-left">
                                                                <div class="service-container"
                                                                    v-for="(speciality, index) in item.practitioner_speciality"
                                                                    :key="index">
                                                                    <span style="background-color: #F5F5F5;">{{
                                                                        speciality.practitioner_speciality }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="doc-info-left">
                                                        <div class="clini-infos">
                                                            <ul>
                                                                <li v-if="item.feedback_count">
                                                                    <i class="far fa-comment"></i>
                                                                    {{ item.feedback_count }} Feedback
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <router-link :to="{
                                                                name: 'doctor-profile',
                                                                params: { name: item.name },
                                                            }">
                                                                <button class="book_appointment btn btn-primary mt-1">
                                                                    Profile
                                                                </button>
                                                            </router-link>
                                                        </div>
                                                        <div class="col-md-7">
                                                            <div class="d-md-flex">
                                                                <button v-if="item.booking_appoinment === 0"
                                                                    class="btn btn-secondary mt-1"
                                                                    style="background-color:#D3D3D3;color:white;border:none;">No
                                                                    Schedule</button>
                                                                <button v-else-if="item.booking_appoinment === 1"
                                                                    class="book_appointment btn btn-primary mt-1"
                                                                    style="color:white;border:none;"
                                                                    @click="check_book_appointment(item.name)">Book
                                                                    Appointment</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-if="doctors.length > 0">
                                        <div>
                                            <h5 class="mt-1" style="color: #8d8c8c;">Total Doctors : {{ totalCount }}</h5>
                                        </div>
                                    </div>
                                    <!-- pagination start -->
                                    <div class="pagination-container" >
                                        <div v-if="doctors.length > 0" class="justify-content-center">
                                            <b-pagination v-model="search_params.page" :total-rows="totalCount"
                                                :per-page="search_params.size" prev-text="Prev" next-text="Next"
                                                @change="handleChangePage"></b-pagination>
                                        </div>
                                    </div>
                                    <!-- pagination end -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <layout-footer v-if="doctors.length > 0"></layout-footer>
    </div>
</template>
    
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import CommonApi from "../../services/CommonApi";
import StarRating from "vue-star-rating";
import { mapState } from "vuex";
import axios from "axios";

export default {
    components: { StarRating, VueGoogleAutocomplete },
    data() {
        return {
            isDataLoaded: false,
            success_message: "",
            error_message: "",
            sub_categories: [],
            selected_complaint: "",
            doctorNameFilter: "",
            domain_for: "",
            showspinner: true,
            selected_city: "",
            selected_complaint: "",
            categories: [],
            selected_category: "",
            doctors: [],
            totalCount: 0,
            search_params: {
                city: "",
                page: 1,
                size: 12,
                hospital: this.$route.params.name,
            }
        };
    },
    mounted() {
        this.get_doctors().then(() => {
            this.isDataLoaded = true;
        });
        this.get_doctors();
        this.get_practitioner_profile();
        const autocomplete = new google.maps.places.Autocomplete(
            this.$refs["autocomplete"]
        );
        var self = this;
        autocomplete.addListener("place_changed", function () {
            self.get_doctors(false);
        });
    },
    computed: {
        ...mapState({
            user_id: (state) => state.user.user_id,
            user_type: (state) => state.user.user_type,
        }),
        currentpath() {
            return this.$route.name;
        },
    },
    methods: {
        //pagination start
        handleChangePage(newPage) {
            this.search_params.page = newPage;
            this.get_doctors();
        },
        //pagination end

        initMap: function () {
            alert("ok");
        },

        //   onLocationEmpty() {
        //     if (document.getElementById("map").value === "") {
        //       this.search_params.lattitude = "";
        //       this.search_params.longitude = "";
        //       this.get_doctors(false);
        //     }
        //   },
        async check_book_appointment(id) {
            this.$swal({
                text: "Checking Schedule...",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            const data = new URLSearchParams();
            data.append("practitioner", id);
            await CommonApi.get_data(
                "sahaj.appointment.check_practitioner_schedule",
                data
            ).then((res) => {
                if (res && res.status_code === 200) {
                    this.$swal.close();
                    this.$router.push({
                        name: "booking",
                        params: { name: id },
                    });
                } else {
                    this.$swal.close();
                    this.$swal.fire({
                        icon: "error",
                        title: "Error",
                        text: res.message,
                        showConfirmButton: true,
                    });
                }
            });
        },
        /* Add Doctor As Favourite  */
        // async add_favourite_Doctor(doctor) {
        //   this.$swal({
        //     text: "Adding Doctor As Favourite",
        //     showConfirmButton: false,
        //     allowOutsideClick: false,
        //     didOpen: () => {
        //       this.$swal.showLoading();
        //     },
        //   });
        //   let data = {
        //     practitioner: doctor,
        //     patient: this.user_id,
        //   };
        //   await CommonApi.post_data(
        //     "sahaj.finalapi.add_validate_patient_doctors_list",
        //     data
        //   ).then((res) => {
        //     if (res.message === "Doctor already exists to Patient") {
        //       this.$swal.fire({
        //         icon: "warning",
        //         title: "Already Exists",
        //         text: res.message,
        //         showConfirmButton: true,
        //       });
        //     } else {
        //       this.add_favourite_Doctor_again(doctor);
        //     }
        //   });
        // },


        async add_favourite_Doctor(doctor) {
            this.$swal({
                text: "Adding Doctor As Favourite",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            let data = {
                practitioner: doctor,
                patient: this.user_id,
            };
            await CommonApi.post_data("sahaj.finalapi.favorite_doctor", data).then(
                (res) => {
                    if (res && res.status_code === 200) {
                        this.$swal.fire({
                            icon: "success",
                            title: "Success",
                            text: res.message,
                            showConfirmButton: true,
                        });
                    }
                    else {
                        this.$swal.fire({
                            icon: "warning",
                            title: "Warning",
                            text: res.message,
                            showConfirmButton: true,
                        });
                    }
                }
            );
        },


        get_doctor_qualification(qualification) {
            var qualification_string = [];
            qualification.map((data) => {
                qualification_string.push(data.qualification);
            });
            return qualification_string.join(" , ");
        },
        next() {
            this.$refs.slick.next();
        },
        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
        loadImg(imgPath) {
            return images("./" + imgPath);
        },
        loadDocImg(imgPath) {
            return "https://develop-physio.kneexpert.in" + imgPath;
        },

        async get_practitioner_profile() {
            this.showspinner = false;
            try {
                const response = await axios.get(
                    "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
                    window.location.hostname
                );

                if (response.data.status_code === 200) {
                    this.domain_data = response.data.data[0]
                    this.domain_for = response.data.data[0].domain_for;

                    if (this.domain_for === "Hospital Portal") {
                        try {
                            const categoriesResponse = await axios.get(
                                "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital_departments?hospital=" +
                                response.data.data[0].hospital
                            );
                            if (categoriesResponse.data.status_code === 200) {
                                this.categories = categoriesResponse.data.data; // Assign the data to categories
                                this.selected_hospital = response.data.data[0].hospital;
                                return response.data.data[0];

                            }
                        } catch (error) {
                            console.error("Error fetching hospital categories: ", error);
                        }
                    } else {
                        // Use a different API URL if domain_for is not "Hospital Portal"
                        const param = {
                            complaints_treatment_offered: this.selected_complaint,
                        };
                        try {
                            const response = await CommonApi.get_data(
                                "sahaj.finalapi.get_healthcare_categories",
                                param
                            );

                            if (response.status_code === 200) {
                                this.categories = response.data;

                                // Return null as there's no hospital information in this case
                                return null;
                            }
                        } catch (error) {
                            console.error("Error fetching categories: ", error);
                        }
                    }
                } else if (response.data.status_code === 404) {
                    // Handle other cases based on window.location.hostname if needed
                    if (window.location.hostname == "physio.sahajhelp.com") {
                        // Handle other cases here if needed
                               } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
                        // Handle other cases here if needed
                    }
                    else if (window.location.hostname.startsWith("192.168")) {
                    } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
                        // Handle other cases here if needed
                    } else {
                        window.location.href = String("https://physio.kneexpert.in");
                    }
                }

                this.$swal.close();
            } catch (error) {
                console.error("Error fetching practitioner profile: ", error);
            }

            // Return null if there's an error
            return null;
        },

        async get_doctors() {

            const hospitalInfo = await this.get_practitioner_profile();
            if (hospitalInfo) {
                this.selected_hospital = hospitalInfo.hospital; // Use the hospital information in your code
                this.selected_city = hospitalInfo.city;
            }

            // Check if this.domain_for is "Hospital Portal" before including the hospital parameter
            if (this.domain_for === "Hospital Portal") {
                this.search_params.hospital = this.selected_hospital;
            }

            // Include the city in the search_params
            if (this.domain_for === "City Portal") {
                this.search_params.city = this.domain_data.city;
            }
            this.search_params.page = this.search_params.page;
            this.search_params.size = this.search_params.size;
            let search = new URLSearchParams(this.search_params);
            search.append("name", this.doctorNameFilter);
            await CommonApi.get_data(
                "sahaj.finalapi.get_doctor_list_v3",
                search
            ).then((res) => {
                console.log(res)
                this.totalCount = res.data.count;
                this.doctors = res.data.data
                this.$swal.close();
            });
        },
    },
};
</script>
    
<style scoped>
.fa-heart {
    color: red;
}

.content {
    min-height: 20px;
    padding: 30px 0 0;
}

.book-appointment {
    cursor: pointer;
}

.book_appointment:hover {
    background-color: mediumseagreen;
}

.clinic-services {
    color: #272b41;
}

.service-container {
    box-sizing: border-box;
    /* Two items per row */
    margin: 1px;
    display: inline-block;

}

.clinic-services span {
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 10px;
    padding: 3px 3px;
}

.card {
    border: 1px solid #ccc;
    padding: 10px;
    text-align: center;
    margin: 0 10px;
    box-sizing: border-box;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    /* Adjust the margin as needed */
}

@media screen and (min-width: 1024px) {

    .form-group {
        margin-left: auto;
        /* Center the form group horizontally */
        margin-right: auto;
        width: 430px;
    }
}
</style>
    


// WEBPACK FOOTER //
// src/components/kneexpert/HospitalDoctors.vue